<template>
    <div id="agaccount" class='gcardfr' v-loading='loading'>

        <el-row :gutter="20" class=''>
            <el-col :span='8'>
                <div class="glineflex">
                    <label class="glinelb">广告文本：</label>
                    <el-input size='small' v-model='adText' @keyup.enter.native="indexget"></el-input>
                </div>
            </el-col>

        </el-row>
        <el-table class='gtbtop' tooltip-effect="dark" :data="tableData" style="width: 100%">
            <el-table-column prop="adText" label="广告文本">
            </el-table-column>
            <el-table-column prop="fileSize" label="文件大小">
            </el-table-column>
            <el-table-column label="状态">
                <template slot-scope="scope">
                    <span v-if="scope.row.status == '0'">待审核</span>
                    <span v-if="scope.row.status == '1'">审核完成</span>
                    <span v-if="scope.row.status == '2'">审核失败</span>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="200">
            </el-table-column>
            <el-table-column :label="$t('app_operation')" width="140">
                <template slot-scope="scope">
                    <el-button type='text' @click='texts(scope.row)'>下载语料</el-button>
                </template>
            </el-table-column>
        </el-table>

        <Pages class='gpages' :cpage='page' :ctotal="total" :config='pconfig'></Pages>
    </div>
</template>

<style>
.edttcolor {
    margin-top: 20px;
}

.eqbs-ball-green {
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 6px;
    overflow: hidden;
    background: rgba(82, 196, 26, 1);
}

.eqbs-ball-gray {
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 6px;
    overflow: hidden;
    background: rgba(191, 191, 191, 1);
}
</style>

<script>
import Pages from '@/components/Pages.vue'
export default {
    data() {
        return {
            adText: '',
            forms: {},
            isEdit: false,
            srcKey: '',
            pconfig: '',
            tableData: [],
            showDia: false,
            uform: {
                strategyData: {}
            },
            page: 1,
            total: 0,
            loading: false,
            sRows: [],
            innerVisible: false,
            beginTime: '',
            endTime: '',
        }
    },
    components: {
        Pages,
    },
    methods: {
        texts(item) {
            window.open(item.textUrl)
        },
        indexget() {
            this.page = 1
            this.getList()
        },
        getList() {
            this.loading = true
            this.$marketLanguageMaterial(this.page, this.$gRow, this.adText, res => {
                this.loading = false
                if (res.status == 200) {
                    this.total = res.total
                    this.tableData = res.data
                } else {
                    this.$message.error(res.message)
                }
            }, '')
        },
        batchSelected(val) {
            this.sRows = val
        },
        closeDia() {
            this.showDia = false
            this.uform = { strategyData: {} }
        },
    },
    mounted() {
        var _this = this
        this.pconfig = {
            callback: page => {
                ///
                _this.page = page
                _this.getList()
            }
        }

        // this.setMc('')

        this.getList()
    }
}
</script>
